<template>
  <BookmarkBody/>
</template>

<script>
// @ is an alias to /src
import BookmarkBody from '@/components/BookmarkBody.vue'

export default {
  name: 'BookmarkView',
  components: {
    BookmarkBody
  }
}
</script>
